<template>
  <div id="body">
    <h1>Form</h1>

    <div>
      <form action="">
        <fieldset id="form_pt1">
          <div>
            <!-- Campaign name  -->
            <label for="">Nome da Campanha: </label> <br />
            <input
              v-model="cc_campaign.name"
              type="text"
              id="campaign-name"
              name="campaign-name"
            />
          </div>

          <div>
            <!-- Select type of campaign  -->
            <label for="select-campaing-type"
              >Selecione o tipo de campanha que quer inserir:</label
            >
            <br />
            <select
              @change="onSelectCampaignType($event)"
              v-model="campaign_type_key"
              id="select-campaing-type"
            >
              <option
                v-for="(campaign_enum, i) in campaign_enums"
                v-bind:key="i"
                v-bind:value="campaign_enum.enum"
              >
                {{ campaign_enum.text }}
              </option>
            </select>
          </div>
        </fieldset>

        <!-- Image campaign type   -->
        <fieldset v-if="campaign_type_key == 'IMAGE'">
          <legend>Campanha de Imagem</legend>
          <label for="image-url">URL da Imagem:</label>
          <input
            v-model="cc_campaign.image.url"
            id="image-url"
            name="image-url"
            type="text"
          />
        </fieldset>

        <!-- Video campaign type   -->
        <fieldset v-if="campaign_type_key == 'VIDEO'">
          <legend>Campanha de Video</legend>
          <label for="video-url">Link do Youtube: <a href="" style="color: #097973;">ajuda</a></label> 
          <!-- TODO: Fazer o vídeo de como criar a campanha de vídeo e colocar o link aqui -->
          <input
            v-model="cc_campaign.video.youtube_url"
            id="video-url"
            name="video-url"
            type="text"
          />
          <label for="video-height">Height</label>
          <input
            v-model="cc_campaign.video.height"
            id="video-height"
            name="video-height"
            type="number"
          />
          <label for="video-width">Width</label>
          <input
            v-model="cc_campaign.video.width"
            id="video-width"
            name="video-width"
            type="number"
          />
        </fieldset>

        <!-- Redirect campaign type  -->
        <fieldset v-if="campaign_type_key == 'REDIRECT'">
          <legend>Campanha de Redirecionamento</legend>
          <label for="redirect-url">URL de redirecionamento:</label>
          <input
            v-model="cc_campaign.redirect.url"
            id="redirect-url"
            name="redirect-url"
            type="text"
          />

          <label for="redirect-content-type">Tipo de conteúdo:</label>
          <select
            v-model="redirect_content_type_key"
            @change="onSelectRedirectContentType($event)"
            id="redirect-content-type"
          >
            <option
              v-for="(content_type, i) in content_types"
              v-bind:value="content_type.type"
              v-bind:key="i"
            >
              {{ content_type.text }}
            </option>
          </select>
        </fieldset>

        <!-- Reward campaign type   -->
        <fieldset v-if="campaign_type_key == 'REWARD'">
          <legend>Campanha de Recompensa</legend>
          <h3 style="background-color: red; color: aliceblue;">NÃO FOI DESENVOLVIDO AINDA</h3>
          <!-- <label for="reward-url">URL da Recompensa:</label>
          <input
            v-model="cc_campaign.reward.url"
            id="reward-url"
            name="reward-url"
            type="text"
          /> -->
        </fieldset>

        <button @click="replaceNameSpaces(),sendToDb($event)">Salvar Campanha</button>
      </form>
      <dialog id="modal-dialog">
        <p>{{ dialogMessage }}</p>
        <p id="put-this-shit-here"></p>
        <button @click="closeDialog($event)">OK!</button>
      </dialog>
    </div>
  </div>
</template>

<script>
import { saveCampaign } from "../services/api";
import { contentTypes, campaignEnum } from "../helpers"

export default {
  name: "form-page",
  components: {},
  data() {
    return {
      dialogMessage: "",
      campaign: this.$route.fullPath,
      cc_campaign: {
        name: "",
        type: "",
        image: {
          url: "",
          height: "198",
          width: "300",
        },
        video: {
          youtube_url: "",
          height: "1211",
          width: "681",
        },
        redirect: {
          url: "",
          contentType: "",
        },
        reward: {
          url: "",
          contentType: "",
        },
      },
      campaign_enums: campaignEnum,
      content_types: contentTypes,
      campaign_type_key: "",
      redirect_content_type_key: "",
    };
  },

  methods: {
    setup() {
      console.log("setup");
      // const enums = await getEnums()
      // this.content_types = enums.contentTypeEnum
      // this.campaign_enums = enums.campaignEnum
      
      // enums.contentTypeEnum.map((type) => {
      //   console.log(type);
      // })
    },

    replaceNameSpaces(){
      this.cc_campaign.name = this.cc_campaign.name.replace(/\s/g, '_')
    },

    onSelectCampaignType(event) {
      this.cc_campaign.type = event.target.value;
    },

    onSelectRedirectContentType(event) {
      this.cc_campaign.redirect.contentType = event.target.value;
    },

    closeDialog: function (event) {
      document.querySelector("#modal-dialog").close();
      event.preventDefault;
    },

    sendToDb: async function (event) {
      event.preventDefault();
      
      //REWARD DO NOT SEND
      if(this.campaign_type_key === "REWARD") return

      if(!(this.campaign_type_key && this.cc_campaign.name)){
        this.dialogMessage = "Preencha os dados!";
        document.querySelector("#modal-dialog").showModal();
        return
      }

      const id = await saveCampaign(this.cc_campaign);
      if (!id) {
        this.dialogMessage = "Não conseguimos salvar essa campanha.";
        document.querySelector("#modal-dialog").showModal();
      } else {
        this.campaign_type_key
        this.dialogMessage = `Sua campanha de ${this.campaign_type_key} foi salva com sucesso!`;
        document.querySelector("#modal-dialog").showModal();
        let link = `https://${window.location.host}/${this.campaign_type_key.toLowerCase()}/${id}`
        let linkElement = document.getElementById("put-this-shit-here")
        linkElement.innerHTML = `Esse é o link: <a href="${link}">${link}</a>`
      }
    },
  },
};
</script>

<style scoped>
#body {
  margin: 5%;
  text-align: left;
}

form {
  width: 90%;
  padding: 4%;

  background-color: #233242;
  color: white;

  border-radius: 10px;
}

fieldset {
  display: grid;

  margin-bottom: 5%;
  border: 2px solid #ffff;
  border-radius: 2%;
}

fieldset input,
select {
  width: 90%;
  padding: 8px;
}

label {
  padding-bottom: 10px;
}

@media (min-width: 800px) {
  #form_pt1 {
    grid-template-columns: 2fr 1fr;
  }
}
</style>
